import router from '../router';

export default {
  beforeRouteEnter(to, from, next) {
    // Check the flag before the component instance is created
    const isShallowNavigation = router._isShallowNavigation;
    next(vm => {
      // Skip loading on shallow route navigation
      if (!isShallowNavigation) {
        vm.form = null;
        vm.message = null;
        vm.entryId = null;
        vm.showSupervisionTypeForm = true;
        vm.onLoad();
      } else {
        // On shallow routing, just update the entryId without reloading
        if (to.params.id) {
          vm.entryId = to.params.id;
        }
      }
    });
  },
  
  beforeRouteLeave(to, from, next) {
    if (this.$refs.form && this.$refs.form.leavingRoute) {
      this.$refs.form.leavingRoute(to, from, next);
    } else {
      next();
    }
  }
};

